import React, { useContext } from 'react';
import type { WCmsHomepageSectionView, WCmsVideoView } from '@zola/svc-web-api-ts-client';
import VideoSnippet from 'components/util/VideoSnippet';
import Story from './Story';
import { Container } from './StorySection.styles';
import { ThemeContext } from '../../../context';

const StorySection = ({
  homepageSections,
  video,
  className,
  textAlignment,
}: {
  homepageSections?: WCmsHomepageSectionView[];
  video?: WCmsVideoView;
  className?: string;
  textAlignment: string;
}): JSX.Element | null => {
  const {
    components: { cmsEntityComponentBodyFontValues },
  } = useContext(ThemeContext);

  if (video || (homepageSections && homepageSections.length > 0)) {
    return (
      <Container
        className={className}
        fontFamily={cmsEntityComponentBodyFontValues.fontFamily}
        fontColor={cmsEntityComponentBodyFontValues.color}
      >
        {video && (
          <VideoSnippet
            url={video.url}
            caption={video.caption}
            id={video.id}
            key={video.id}
            additionalPaddingBottom={!homepageSections?.length}
          />
        )}
        {homepageSections?.map((s, i) => (
          <Story {...s} key={i} textAlignment={textAlignment} />
        ))}
      </Container>
    );
  }

  return null;
};

export default StorySection;
